/* eslint-disable */
import axios from "axios";
let baseURL = process.env.VUE_APP_API_URL
// let baseURL = "https://yapi.baidu.com/mock/17592"  //模拟假的数据：接口
let platform = 'web'
const instance = axios.create({
  baseURL,
  timeout: 10000,
})
const setGraphSign = (tokenInfo) => {
	// let time = new Date().getTime().toString();
	// let sperate = ',';
	// return `${md5(time + sperate +  tokenInfo.http_cloud_service.client_key)},${time}`;
};
const setHeader = (tokenInfo,type) => {
  // header = {
  //   'Content-Type': type === 'POST' ? 'application/json;charset=utf-8' : 'application/x-www-form-urlencoded;charset=utf-8',
  //   'identity_code': openid ?? '',
  //   'Authorization': `Bearer ${tokenInfo && tokenInfo.token}`,
  //   'X-Project-ID': tokenInfo && tokenInfo.http_cloud_service && tokenInfo.http_cloud_service.xproject_id,
  //   'X-Sign': tokenInfo && setGraphSign(tokenInfo)
  // }
	// return header
}
// Add a request interceptor
instance.interceptors.request.use(
  config => {
    // Do something before request is sent
    let params = {
      platform: platform
    }
    if (config.method === 'get') {
      config.params = config.params || {}
      Object.assign(config.params, params)
    }
    if (config.method === 'post') {
      config.data = config.data || {}
      config.dataType = 'json'
      Object.assign({}, config.headers)
    }
    return config
  },
  error => {
    // Do something with request error
    Promise.reject(error)
  }
)

// Add a response interceptor
instance.interceptors.response.use(
  response => {
    // Do something with response data
    if (response.data && Number(response.data.code) === 1) {
      return Promise.resolve(response.data)
    } else {
      return Promise.reject(response.data)
    }
  },
  error => {
    // Do something with response error
    let errorMsg = ''
    if (error && error.code === 'ECONNABORTED') {
      errorMsg = 'request timeout'
    }
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '错误请求'
          break
        case 401:
          error.message = '未授权'
          break
        case 403:
          error.message = '禁止访问'
          break
        case 404:
          error.message = '未找到请求资源'
          break
        case 500:
          error.message = '服务端错误'
          break
        default:
          error.message = `请求错误：${error.response.status}`
      }
    } else {
      error.message = '请求发送失败'
    }
    errorMsg = error.message
    errorMsg = '出错了，请稍后再试'
    return Promise.reject(errorMsg)
  }
)

export default instance
